import React from 'react';
import { Box, Icon, Copy } from '@honda-canada/design-system-react';
import themeStyles from './SignupForUpdates.styles';
import FormFields from './FormFields';
var SignupContainer = themeStyles.apply(Box, 'SignupContainer');
var HeaderContainer = themeStyles.apply(Box, 'HeaderContainer');
var Title = themeStyles.apply(Copy, 'Title');
var Description = themeStyles.apply(Copy, 'Description');
var Body = themeStyles.apply(Box, 'Body');
var CloseButton = themeStyles.apply('button', 'CloseButton');
var SignupForUpdatesUI = function (_a) {
    var closeModal = _a.closeModal, title = _a.title, body = _a.body, legalDisclaimer = _a.legalDisclaimer, formName = _a.formName, pageUrl = _a.pageUrl, ctaButton = _a.ctaButton;
    return (React.createElement(SignupContainer, null,
        React.createElement(HeaderContainer, { "data-testid": "cy-signup-header" },
            React.createElement(CloseButton, { as: "button", onClick: closeModal },
                React.createElement(Icon, { name: "close" })),
            React.createElement(Title, { size: "quoteBody", "data-testid": "cy-signup-title" }, title),
            React.createElement(Description, { "data-testid": "cy-signup-description", size: "regular" }, body)),
        React.createElement(Body, null,
            React.createElement(FormFields, { legalDisclaimer: legalDisclaimer, formName: formName, pageUrl: pageUrl, ctaButton: ctaButton }))));
};
export default SignupForUpdatesUI;
